import React from 'react';
import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';
import RadioButtons, { RadioButtonsProperties } from '../RadioButtons';
import FilterOverlay from './FilterOverlay';
import FilterHeading from './FilterHeading';
import breakpoints from '../Theme/breakpoints';

const RadioButtonFilterWrapper = styled.div<{ loadingProp?: boolean }>`
  margin: 0 0 20px;
  padding: 0 0 4px;
  display: flex;
  flex-wrap: wrap;
  filter: blur(${({ loadingProp }) => (loadingProp ? '2px' : '0px')});

  .MuiFormControlLabel-label {
    font-size: 0.8rem;
    font-weight: bold;
    line-height: 1rem;
    margin: 4px 0 4px;
  }

  @media (min-width: ${breakpoints.md}px) {
    margin: 0 0 32px;
  }
`;

const RadioButtonWrapper = styled.div`
  margin: 4px 0 0;
  padding: 0 6px;

  @media (min-width: ${breakpoints.md}px) {
    margin: 0;
  }
`;

const radioButtonFilterPropertyTypes = {
  loading: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

type RadioButtonFilterProperties = InferProps<
typeof radioButtonFilterPropertyTypes> & RadioButtonsProperties & {
  loading?: boolean;
  title: string;
};

const RadioButtonFilter = ({
  title,
  loading = false,
  name,
  values,
  value,
  onChange,
}: RadioButtonFilterProperties) => (
  <RadioButtonFilterWrapper loadingProp={loading}>
    { loading && <FilterOverlay /> }
    <FilterHeading tag="h2" modal>
      {title}
    </FilterHeading>
    <RadioButtonWrapper>
      <RadioButtons
        onChange={onChange}
        name={name}
        value={value}
        values={values}
      />
    </RadioButtonWrapper>
  </RadioButtonFilterWrapper>
);

RadioButtonFilter.propTypes = radioButtonFilterPropertyTypes;

export default RadioButtonFilter;
